// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"964":"dd80c1b6","3816":"dd80c1b6","4084":"dd80c1b6","5822":"dd80c1b6","8724":"dd80c1b6","9645":"dd80c1b6","9807":"dd80c1b6"}[chunkId] + ".chunk.css";
};